// extracted by mini-css-extract-plugin
export default {"root":"loadingpage_root__Ng09P"};